import React from 'react';
import { motion } from 'framer-motion';
export function Philosophy() {
  return <section id="experience" className="py-28 lg:py-40 bg-cream-50" data-id="element-130">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="lg:col-span-5" data-id="element-132">
          <div className="flex items-center gap-3 mb-6" data-id="element-133">
            <span className="h-px w-10 bg-lilac-400/60" data-id="element-134" />
            <span className="text-[10px] uppercase tracking-luxe text-lilac-500" data-id="element-135">
              Our Philosophy
            </span>
          </div>
          <h2 className="font-serif text-5xl lg:text-6xl text-ink leading-[1.05]" data-id="element-136">
            A quiet ritual <br data-id="element-137" />
            of <span className="italic text-lilac-500" data-id="element-138">renewal.</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="lg:col-span-7 lg:pt-4" data-id="element-139">
          <p className="text-lg leading-relaxed text-ink/75 mb-6 font-light" data-id="element-140">
            At Wonders of Life, we believe wellness is not a luxury reserved for
            a few—it is something everyone deserves access to.
          </p>
          <p className="text-lg leading-relaxed text-ink/75 mb-6 font-light" data-id="element-141">
            True wellness is not a destination, but a return: to softness, to
            breath, and to the unhurried rhythm of being. In a world that
            constantly asks more of us, we create space for rest, healing, and
            renewal.
          </p>
          <p className="text-lg leading-relaxed text-ink/75 mb-6 font-light" data-id="element-142">
            Each treatment is thoughtfully designed, blending time-honored
            botanical traditions with modern therapeutic science to nurture both
            body and mind.
          </p>
          <p className="text-lg leading-relaxed text-ink/75 mb-6 font-light" data-id="element-143">
            Our suites are peaceful sanctuaries of warm textures, soft linens,
            and a calming atmosphere. Here, you are invited to step away from
            the noise, slow down, and reconnect with yourself.
          </p>
          <p className="text-lg leading-relaxed text-ink/75 mb-6 font-light" data-id="element-144">
            Most importantly, we believe self-care should be accessible. That's
            why we are committed to offering high-quality wellness services at
            affordable prices, ensuring that everyone has the opportunity to
            receive the care, relaxation, and healing they deserve.
          </p>
          <p className="text-xl italic text-lilac-500 mb-10" data-id="element-145">
            Take a breath. Be present. Receive what your body has been asking
            for.
          </p>

          <svg width="120" height="40" viewBox="0 0 120 40" fill="none" className="text-lilac-400" data-id="element-146">
            <path d="M2 20 Q 30 2, 60 20 T 118 20" stroke="currentColor" strokeWidth="0.8" fill="none" data-id="element-147" />
            <circle cx="60" cy="20" r="2" fill="currentColor" data-id="element-148" />
          </svg>
        </motion.div>
      </div>
    </section>;
}